module.exports = __webpack_public_path__ + "img/close-chip.72eb5c14.svg";